module.exports = __webpack_public_path__ + "static/media/LT.398e7806.png";